import currency from 'currency.js';
import Dinero from 'dinero.js';
import { Money as IMoney } from 'src/app/api/models';

export class Money implements IMoney {
  private _d: Dinero.Dinero;

  constructor(d: IMoney | Dinero.Dinero) {
    if (!d) {
      this._d = null;
      return;
    }

    if (Money.isDinero(d)) {
      this._d = d;
    } else {
      this._d = Dinero({ amount: currency(d.amount).intValue, currency: d.currency as Dinero.Currency });
    }
  }

  public get amount() {
    if (this.isZero()) {
      return null;
    }
    return currency(this._d.getAmount(), { fromCents: true, precision: this._d.getPrecision() }).toString();
  }

  public get currency() {
    if (this.isZero()) {
      return null;
    }

    return this._d.getCurrency().toString();
  }

  toJSON() {
    if (this._d == null) {
      return null;
    }
    return {
      amount: this.amount,
      currency: this.currency,
    }
  }

  toDinero(): Dinero.Dinero {
    if (this._d == null) {
      return Dinero({ amount: 0, currency: 'EUR' });
    }

    return this._d;
  }

  isZero(): boolean {
    return this._d === null
  }

  static isDinero(d: IMoney | Dinero.Dinero): d is Dinero.Dinero {
    if (!d) {
      return false;
    }
    return (d as Dinero.Dinero).getAmount !== undefined;
  }
}
